import {
  CONTENT_FULFILLED,
  CONTENT_PENDING,
  CONTENT_REJECTED,
  CONTENT_ROUTE,
  PREVIEW_TOKEN_CHANGED,
  BRAZE_CONTENT_CARD_FULLFILED,
} from '../actions';

import ContentSlice from '../models/ContentSlice';

const updateState = (state, newState) => ({
  ...state,
  ...newState,
});

const injectIntoHeaderBanner = (content, newBanner) => {
  const slices = content.body;
  const [firstSlice] = slices;

  if (!firstSlice.type.startsWith('header')) {
    const headerBanner = {
      ...(ContentSlice()),
      ...{ items: newBanner, sliceId: 1, type: 'header_2' },
    };

    const modifiedSlices = slices.map(slice => ({
      ...slice,
      ...{ sliceId: (slice.sliceId || 1) + 1 },
    }));

    return {
      ...content,
      ...{ body: [headerBanner].concat(modifiedSlices) },
    };
  }

  firstSlice.items = firstSlice.items.concat(newBanner);
  return content;
};

const content = (state = {}, action) => {
  switch (action.type) {
    case CONTENT_ROUTE:
      return updateState(state, action.payload);
    case CONTENT_PENDING:
      return updateState(state, {
        busy: true,
      });
    case CONTENT_FULFILLED:
      return updateState(state, {
        busy: false,
        error: undefined,
        content: action.payload,
      });
    case CONTENT_REJECTED:
      return updateState(state, {
        busy: false,
        error: action.payload,
      });
    case PREVIEW_TOKEN_CHANGED:
      return updateState(state, {
        previewToken: action.payload,
      });

    case BRAZE_CONTENT_CARD_FULLFILED: {
      const contentClone = JSON.parse(JSON.stringify(state.content));
      try {
        const newContent = injectIntoHeaderBanner(contentClone, action.payload);
        return updateState(state, { content: newContent });
      } catch (err) {
        return state;
      }
    }

    default:
      return state;
  }
};

export default content;
